(function () {
  function animate() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    var icon = bubble.querySelector('.svg-wrapper');
    var count = bubble.querySelector('.cart-count-bubble');

    if (icon) {
      icon.classList.remove('cart-icon--bounce');
      void icon.offsetWidth;
      icon.classList.add('cart-icon--bounce');
      icon.addEventListener('animationend', function () {
        icon.classList.remove('cart-icon--bounce');
      }, { once: true });
    }

    if (count) {
      count.classList.remove('cart-count-bubble--pop');
      void count.offsetWidth;
      count.classList.add('cart-count-bubble--pop');
      count.addEventListener('animationend', function () {
        count.classList.remove('cart-count-bubble--pop');
      }, { once: true });
    }
  }

  var nativeFetch = window.fetch;
  window.fetch = function (url) {
    var promise = nativeFetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      promise.then(function (response) {
        if (response.ok) {
          // setTimeout(0) runs after all microtasks — renderContents will have
          // already updated the DOM by the time animate() fires
          setTimeout(animate, 0);
        }
      });
    }
    return promise;
  };
})();
